/*eslint new-cap:0 */
import ko from 'knockout';

export default class ViewModel {
  constructor() {
    this.autoMatedCTAEnabled = ko.observable(true);
    this.showAutoMatedCTA = ko.observable(false);
  }
}

